// store/authStore.js
import { create } from "zustand";
import { getBannerData } from "../api/home";
import { getEarthWorkData } from "../api/earthWork";

export const useEarthWorkStore = create((set, get) => ({
    loading: true,
    banner: null,
    earthwork: [],

    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('earthworks')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getEarthWork: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await getEarthWorkData(pageNumber, pageSize, search, field)
            console.log("earthwork", res?.ref);
            set({ loading: false, earthwork: res?.ref })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    }

}));
